import { render, staticRenderFns } from "./query.vue?vue&type=template&id=75a88880&"
import script from "./query.vue?vue&type=script&lang=js&"
export * from "./query.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports